import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Box, ButtonBase, makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { ArrowLeftIcon } from '../../../../components/Icon';
import { i18n } from '../../../../language';
import { classNames } from '../../../../utils';
import rouMap from '../../../../router';
import { setEhdSetting } from '../../../../redux/actions';
import { ehandoverAPI} from '../../../../apis';
import AccessControl from './components/AccessControl';
import View from './components/View';
import TwoWayCommunication from './components/TwoWayCommunication';
import ContentTemplate from './components/ContentTemplate';



const useStyles = makeStyles(() => ({
  header: {
    backgroundColor: '#ffffff',
    height: '4.5rem',
    boxShadow: '0 1px 0 0 #e4e7eb',
    padding: '0 3.438rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #e4e7eb',
  },
  arrowLeftIcon: {
    fontSize: '1rem',
    color: '#538fff',
  },
  back: {
    paddingLeft: '1rem',
    fontSize: '1rem',
    color: '#538fff',
    fontFamily: 'NotoSans-Bold',
  },
  editFloorPlanBtn: {
    width: '11.25rem',
    height: '2.75rem',
    borderRadius: '8px',
    backgroundColor: '#538fff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#fff',
  },
  tab: {
    width: '10rem',
    height: '3.875rem',
    borderRadius: '10px 10px 0 0',
    backgroundColor: 'rgba(83,143,255,0.1)',
    fontSize: '1rem',
    color: 'rgba(83,143,255,0.6)',
    fontFamily: 'NotoSans-Bold',
  },
  selected: {
    backgroundColor: '#fff',
    color: '#538fff',
  },
  version: {
    color: '#2e4469',
    fontSize: '1rem',
    fontFamily: 'NotoSans-Bold',
  },
}));

const EHandoverSetting = () => {
  const classes = useStyles();
  const [selectedTab, setSelectedTab] = useState(0);
  const history = useHistory();
  const loginInfo = useSelector((state) => state.loginInfo);
  const dispatch = useDispatch();

  const tabs = [
    { id: 0, name: i18n.t('EHANDOVER_ACCESS_CONTROL'), component: AccessControl },
    { id: 1, name: i18n.t('EHANDOVER_VIEW'), component: View },
    { id: 2, name: i18n.t('EHANDOVER_2_WAY_COMMUNICATION'), component: TwoWayCommunication },
    { id: 3, name: i18n.t('EHANDOVER_CONTENT_TEMPLATE'), component: ContentTemplate },
  ];

  const handleSelectTab = useCallback(
    (id) => () => {
      setSelectedTab(id);
    },
    []
  );

  const Component = useMemo(() => {
    return tabs[selectedTab].component;
  }, [selectedTab]);

  const handleBack = () => {
    history.goBack();
  };

  useEffect(() => {
    if (!loginInfo?.flag) {
      history.push(rouMap.ehandoverRou.path);
    }
  }, [loginInfo?.flag]);

  useEffect( () => {
    (async () => {
      const { result } = await ehandoverAPI.getSettingList({wardId: loginInfo?.wardId ?? 0});
      dispatch(setEhdSetting(result));
    })();
  }, [loginInfo?.wardId])

  return (
    <div>
      <div className={classes.header}>
        <ButtonBase onClick={handleBack}>
          <ArrowLeftIcon className={classes.arrowLeftIcon} />
          <div className={classes.back}>{i18n.t('BEDSTATUS_BACK')}</div>
        </ButtonBase>
      </div>
      <Box padding="1.438rem 3.438rem" bgcolor="#f1f6ff">
        <Box display="flex" gridGap="0.625rem">
          {tabs.map((item) => (
            <ButtonBase
              className={selectedTab === item.id ? classNames(classes.tab, classes.selected) : classes.tab}
              key={item.id}
              id={`tab_${item.id}`}
              onClick={handleSelectTab(item.id)}
            >
              {item.name}
            </ButtonBase>
          ))}
        </Box>
        <Component />
      </Box>
    </div>
  );
};

export default EHandoverSetting;
